import { useMemo } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";
import type { CompetitionTransformed } from "~pages/Competitions/types/competitionTransformed.ts";

export const useExtractCompetitionsFromScope = () => {
  const { data: scopeData, isLoading, refetch } = useGetCurrentUserPermissionScope();
  const { scope, resources } = scopeData || {};

  const competitions = useMemo(() => {
    const competitionResources = resources?.competitions || {};
    const leagueResources = resources?.leagues || {};
    const competitionsList: CompetitionTransformed[] = [];

    scope?.leagueTree?.forEach(({ competitions }) => {
      competitionsList.push(
        ...competitions.map(({ competitionId }) => {
          const leagueId = competitionResources[competitionId].leagueId;
          return { ...competitionResources[competitionId], league: leagueId ? leagueResources[leagueId] : null };
        }),
      );
    });
    return competitionsList;
  }, [scope?.leagueTree, resources?.competitions, resources?.leagues]);

  return {
    competitions,
    isLoading,
    refetch,
  };
};
